/* DFR infinite scroll for collection and search grids (Dawn based theme).
   Loads the next page of products automatically while the shopper scrolls.
   Sold-out products are held back and shown after every in-stock product.
   The normal page links stay in the HTML, so search engines and shoppers
   without JavaScript can still reach every page. */
(function () {
  if (window.__dfrInfiniteScroll) return;
  window.__dfrInfiniteScroll = true;

  var MARGIN = 1400;
  var loading = false;
  var observer = null;
  var sentinel = null;
  var currentList = null;
  var held = [];       // sold-out items waiting for the end of the list

  function stateKey() { return 'dfr-inf:' + location.pathname + location.search; }

  function listIn(root) {
    var g = root.querySelector('#product-grid');
    if (!g) return null;
    if (g.tagName === 'UL') return g;
    return g.querySelector('ul.product-grid') || g.querySelector('ul.grid');
  }

  function findSentinel() { return document.querySelector('.dfr-infinite-scroll[data-infinite-next]'); }

  function cardKey(li) {
    var a = li.querySelector('a[href*="/products/"]');
    if (!a) return '';
    return (a.getAttribute('href') || '').split('?')[0];
  }

  function isSoldOut(li) { return li.getAttribute('data-available') === 'false'; }

  function fetchHtml(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    });
  }

  // Called whenever a new product grid appears (first load, filter or sort change).
  function setupGrid(list) {
    held = [];
    if (!list) return;
    var sold = Array.prototype.filter.call(list.children, isSoldOut);
    if (!sold.length) return;
    if (findSentinel()) {
      sold.forEach(function (li) { list.removeChild(li); held.push(li); });
    } else {
      sold.forEach(function (li) { list.appendChild(li); });
    }
  }

  function flushHeld(to) {
    if (!held.length || !to) return;
    var frag = document.createDocumentFragment();
    held.forEach(function (li) { li.setAttribute('data-dfr-appended', ''); frag.appendChild(li); });
    held = [];
    to.appendChild(frag);
  }

  function bind() {
    var list = listIn(document);
    if (list !== currentList) {
      currentList = list;
      setupGrid(list);
    }
    var s = findSentinel();
    if (s === sentinel) return;
    if (observer) observer.disconnect();
    sentinel = s;
    if (!s) return;
    if (!('IntersectionObserver' in window) || !window.fetch || !window.DOMParser) {
      s.classList.add('is-manual');
      return;
    }
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { load(); break; }
      }
    }, { rootMargin: '0px 0px ' + MARGIN + 'px 0px' });
    observer.observe(s);
  }

  function nearViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight + MARGIN;
  }

  // Page URL for the product grid only (Shopify section rendering keeps each response small).
  function pageUrl(base, n, sectionOnly) {
    var u = new URL(base, location.href);
    u.searchParams.set('page', n);
    if (sectionOnly) {
      var g = document.getElementById('product-grid');
      var sid = g ? g.getAttribute('data-id') : '';
      if (sid) u.searchParams.set('section_id', sid);
    }
    return u.pathname + u.search;
  }

  function appendFrom(from, to, seen) {
    if (!from || !to) return;
    var frag = document.createDocumentFragment();
    Array.prototype.slice.call(from.children).forEach(function (li) {
      var k = cardKey(li);
      if (k && seen[k]) return;
      if (k) seen[k] = true;
      li.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
      li.removeAttribute('data-cascade');
      var node = document.importNode(li, true);
      if (isSoldOut(node)) { held.push(node); return; }
      node.setAttribute('data-dfr-appended', '');
      frag.appendChild(node);
    });
    to.appendChild(frag);
  }

  function load() {
    var s = sentinel;
    if (loading || !s || !s.isConnected) return;
    var next = s.getAttribute('data-infinite-next');
    if (!next) return;
    var total = parseInt(s.getAttribute('data-pages'), 10) || 0;
    var first = parseInt(new URL(next, location.href).searchParams.get('page'), 10) || 2;
    // Fetch a few pages at once; more when sold-out items are piling up so in-stock ones keep coming.
    var count = total ? (held.length ? 4 : 2) : 1;
    var batch = [];
    for (var n = first; n < first + count && (!total || n <= total); n++) batch.push(n);
    loading = true;
    s.classList.add('is-loading');
    Promise.all(batch.map(function (n) { return fetchHtml(pageUrl(next, n, true)); }))
      .then(function (pages) {
        if (s !== sentinel) return; // grid was replaced by a filter or sort change
        var to = listIn(document);
        var seen = {};
        if (to) Array.prototype.forEach.call(to.children, function (li) { var k = cardKey(li); if (k) seen[k] = true; });
        held.forEach(function (li) { var k = cardKey(li); if (k) seen[k] = true; });
        var lastDoc = null;
        pages.forEach(function (html) {
          lastDoc = new DOMParser().parseFromString(html, 'text/html');
          appendFrom(listIn(lastDoc), to, seen);
        });
        var nextPage = batch[batch.length - 1] + 1;
        var more = total ? nextPage <= total : !!(lastDoc && lastDoc.querySelector('.dfr-infinite-scroll[data-infinite-next]'));
        if (more) {
          var nu = pageUrl(next, nextPage, false);
          s.setAttribute('data-infinite-next', nu);
          var a = s.querySelector('.dfr-infinite-scroll__more');
          if (a) a.setAttribute('href', nu);
        } else {
          if (observer) observer.disconnect();
          if (s.parentNode) s.parentNode.removeChild(s);
          sentinel = null;
          flushHeld(to);
        }
      })
      .catch(function () {
        if (s.isConnected) s.classList.add('is-manual');
      })
      .then(function () {
        loading = false;
        if (s.isConnected) s.classList.remove('is-loading');
        if (sentinel && sentinel.isConnected && !sentinel.classList.contains('is-manual') && nearViewport(sentinel)) {
          setTimeout(load, 50);
        }
      });
  }

  function save() {
    try {
      var list = listIn(document);
      var added = list ? list.querySelectorAll('[data-dfr-appended]') : [];
      var html = '';
      for (var i = 0; i < added.length; i++) html += added[i].outerHTML;
      var heldHtml = '';
      for (var j = 0; j < held.length; j++) heldHtml += held[j].outerHTML;
      sessionStorage.setItem(stateKey(), JSON.stringify({
        h: html,
        b: heldHtml,
        n: sentinel ? sentinel.getAttribute('data-infinite-next') : '',
        y: window.pageYOffset,
        t: Date.now()
      }));
    } catch (e) { /* storage full or blocked: nothing to restore later */ }
  }

  function restore() {
    try {
      var key = stateKey();
      var raw = sessionStorage.getItem(key);
      if (!raw) return;
      var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      if (!nav || nav.type !== 'back_forward') { sessionStorage.removeItem(key); return; }
      var st = JSON.parse(raw);
      if (!st || Date.now() - st.t > 3600000 || !st.h) return;
      var list = listIn(document);
      var s = findSentinel();
      if (!list || !s) return;
      list.insertAdjacentHTML('beforeend', st.h);
      held = [];
      if (st.b) {
        var tpl = document.createElement('template');
        tpl.innerHTML = st.b;
        held = Array.prototype.slice.call(tpl.content.children);
      }
      if (st.n) s.setAttribute('data-infinite-next', st.n);
      else if (s.parentNode) s.parentNode.removeChild(s);
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var go = function () { window.scrollTo(0, st.y); };
      go();
      setTimeout(go, 150);
      setTimeout(go, 600);
    } catch (e) { /* ignore and start from page one */ }
  }

  function start() {
    document.documentElement.classList.add('dfr-infinite');
    currentList = listIn(document);
    setupGrid(currentList);
    restore();
    bind();
    // Watch the whole page: filters, sorting and some apps replace the product grid container itself.
    new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', save);
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.dfr-infinite-scroll__more') : null;
      if (!a || !sentinel) return;
      e.preventDefault();
      sentinel.classList.remove('is-manual');
      load();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
